export default function setWindowScrollTop(scrollTop) {
  return document.documentElement.scrollTop = document.body.scrollTop = scrollTop;
}